import { render, staticRenderFns } from "./eg_splitpanes.vue?vue&type=template&id=6fc8fbf8&scoped=true&"
import script from "./eg_splitpanes.vue?vue&type=script&lang=js&"
export * from "./eg_splitpanes.vue?vue&type=script&lang=js&"
import style0 from "./eg_splitpanes.vue?vue&type=style&index=0&id=6fc8fbf8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fc8fbf8",
  null
  
)

export default component.exports